import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";

import { AuthProvider } from "./auth/AuthProvider";
import { LanguageProvider } from "./lib/i18n";
import { ThemeProvider } from "./lib/theme";
import { router } from "./shell/router";
import "./styles/tokens.css";

const container = document.getElementById("root");
if (!container) {
  throw new Error("missing #root element");
}

// One QueryClient per process. Defaults favour freshness: per-screen
// lists refetch on mount and on tab refocus so out-of-band writes
// (e.g. notes captured via Telegram) become visible without a manual
// reload. Cheap polling-style queries (sidebar counts) opt back into
// a longer staleTime at their declaration site.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 0, refetchOnWindowFocus: true, retry: 1 },
    mutations: { retry: 0 },
  },
});

createRoot(container).render(
  <StrictMode>
    <ThemeProvider>
      <LanguageProvider>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <RouterProvider router={router} />
          </AuthProvider>
        </QueryClientProvider>
      </LanguageProvider>
    </ThemeProvider>
  </StrictMode>,
);
